import {produce} from "immer";
import {getUserLocation} from "../../Utils/misc/userInsightUtils.ts";

interface UserObj {
    user: any;
    subscriptionPlan: string | null;
    isBeta: boolean;
    remainingBalance: number;
    monthlyFreeMessages: number;
    firstName: string | null;
    fallbackUserId: string | null;
    previousPlans: string[];
    hasUsageBasedEnabled: boolean;
}

export const userSlice = (set: any) => ({
    userObj: {
        user: null,
        subscriptionPlan: null,
        isBeta: false,
        remainingBalance: 0,
        monthlyFreeMessages: 0,
        firstName: null,
        fallbackUserId: null,
        previousPlans: [],
        hasUsageBasedEnabled: false
    },
    setUserObj: (newUserObj: Partial<UserObj>) => set(produce((state: any) => {
        if (newUserObj.user) {
            getUserLocation(state.setUserObj);

            if (newUserObj.user.displayName) newUserObj.firstName = newUserObj.user.displayName.split(' ')[0];
        }
        else if (newUserObj.user === null) {
            newUserObj.firstName = null;
        }

        Object.assign(state.userObj, newUserObj);
    }))
});
